module.exports = __webpack_public_path__ + "static/media/future.078c13fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/future.png
// module id = 9382
// module chunks = 0